
export const CANNONICAL_URL = 'https://www.podiatry-center.com';
export const FACEBOOK_LINK = 'https://www.facebook.com/Център-за-корекция-на-проблемен-впитврастнал-нокът-Медицински-педикюр-342032962534049/';
export const COPYRIGHT = 'Copyright © 2023 Podiatry Center';
